




import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
    components: {},
})
export default class DialogTitle extends Vue {
    @Prop() private title!: string;
}
